import { motion } from "framer-motion";
import { SERVICE_GROUPS } from "./data";

export const Services = () => {
  return (
    <section id="services" className="py-20 md:py-32 bg-white" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <span className="text-sm text-gray-500 uppercase tracking-widest font-semibold">What We Do</span>
          <h2 className="mt-4 font-heading text-3xl sm:text-4xl font-bold tracking-tight text-gray-900">
            Connecting freight, suppliers &amp; supply chains.
          </h2>
          <p className="mt-5 text-base sm:text-lg text-gray-600 leading-relaxed">
            Integrated logistics and supply chain support across transportation, sourcing, and operations — organized so you always know
            exactly how PrimeLane supports your supply chain.
          </p>
        </div>

        <div className="mt-16 space-y-16">
          {SERVICE_GROUPS.map((group, gi) => (
            <div key={group.category} data-testid={`service-group-${gi}`}>
              <div className="flex items-center gap-4 mb-8">
                <h3 className="font-heading text-sm font-bold uppercase tracking-[0.18em] text-[#001E52]">
                  {group.category}
                </h3>
                <div className="flex-1 h-px bg-gray-200" />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {group.items.map((s, i) => {
                  const Icon = s.icon;
                  return (
                    <motion.div
                      key={s.title}
                      initial={{ opacity: 0, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.45, delay: (i % 3) * 0.07 }}
                      className="group border border-gray-200 bg-white p-7 hover:border-[#FE6A04] hover:shadow-lg transition-all duration-300"
                      data-testid={`service-card-${gi}-${i}`}
                    >
                      <div className="w-11 h-11 flex items-center justify-center bg-[#001E52] group-hover:bg-[#FE6A04] transition-colors">
                        <Icon className="text-white" size={20} />
                      </div>
                      <h4 className="mt-5 font-heading text-lg font-semibold text-gray-900">{s.title}</h4>
                      <p className="mt-3 text-sm text-gray-600 leading-relaxed">{s.desc}</p>
                    </motion.div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
